export default __webpack_public_path__ + "static/media/7-min.7f90ff60.jpg";